"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectableOption_Props_1 = require("../../utilities/selectableOption/SelectableOption.Props");
exports.DropdownMenuItemType = SelectableOption_Props_1.SelectableOptionMenuItemType;
//# sourceMappingURL=Dropdown.Props.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Dropdown/Dropdown.Props.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Dropdown/Dropdown.Props.js
// module chunks = 1